<template>
  <div class="manage-product-service-trying">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">
            Danh sách sản phẩm - dịch vụ dùng thử
          </h6>
          <router-link :to="{ name: 'CreateHomeProductService' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="true"
        rowKey="id"
      >
        <template slot="image" slot-scope="row">
          <img
            v-if="row.image"
            :src="row.image"
            alt=""
            class="preview-image-table"
          />
        </template>
        <template slot="status" slot-scope="row">
          <a-switch
            v-model="row.status"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link
              :to="{ name: 'UpdateHomeProductService', params: { id: row.id } }"
            >
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa banner {{ row.name }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {fetchProductService, deleteProductService, updateProductService} from '@/services/landing-page/home/product-service-trying'
import { replaceUrlResource } from '@/utils/common'
  export default {
    name: 'ManageProductServiceTrying',
    data() {
      return {
        callingAPI: true,
        dataSource: [],
        columns: [
          {
            title: 'Tiêu đề',
            dataIndex: 'title',
            class: 'font-semibold',
          },
          {
            title: 'Mô tả',
            dataIndex: 'description',
          },
          {
            title: 'Ảnh',
            scopedSlots: { customRender: 'image' },
            width: 150,
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'status' },
            width: 100,
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: 50,
          },
        ]
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData(loading = true) {
        try {
          this.callingAPI = loading
          const response = await fetchProductService()
          this.dataSource = response.data.map((d) =>({
            ...d,
            status: d.status === 1,
            loadingActive: false,
            image: replaceUrlResource(d.image)
          }))
          this.callingAPI = false
        } catch (error) {
          
        }
      },

      async handleUpdate(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        this.dataSource[index].loadingActive = true
        try {
          const data = {
            ...row,
            status: row.status ? 1 : 2,
            _method: 'PUT'
          }
          delete data.id
          const response = await updateProductService(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          this.dataSource[index].loadingActive = false
        }
      },

      async remove(row) {
        try {
          this.callingAPI = true
          const response = await deleteProductService(row.id, {_method: 'DELETE'})
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Xóa thành công',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Xóa thất bại',
            });
          }
          await this.loadData()
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>